
import { useLocation } from "react-router-dom";
import "./RestricaoUsuario.scss";

export default function RestricaoUsuario({ children }) {
    const location = useLocation();

    // ==========================================================
    // ROTAS BLOQUEADAS PARA USUÁRIO tipo = "u"
    //
    // O usuário "u" não poderá acessar as rotas abaixo.
    // As demais rotas continuam seguindo o comportamento atual.
    // ==========================================================

    const ROTAS_BLOQUEADAS = [
        "/maps/grupos",
        "/maps/grupos-edicao",
        "/maps/grupos-cad",
        "/maps/enfermeiro",

        "/maps/icones",

        "/maps/motorista",
        "/maps/cadastro-motorista",
        "/maps/editar-motorista",

        "/maps/notificacao",
        "/maps/cadastro-notificacao",
        "/maps/editar-notificacao",

        "/maps/usuarios",
        "/maps/cadastro-usuarios",
        "/maps/editar-usuario",

        "/maps/alertas",

        "/maps/areas-rotas",
    ];

    // ==========================================================
    // TIPO DO USUÁRIO
    //
    // Recupera o tipo armazenado no navegador.
    //
    // IMPORTANTE:
    // Esta informação serve para controlar a interface.
    // O backend também precisa validar as permissões.
    // ==========================================================

    const tipo = localStorage.getItem("tipo");

    // ==========================================================
    // ROTA ATUAL
    //
    // Exemplo:
    // /maps
    // /maps/areas-rotas
    // /maps/usuarios
    // ==========================================================

    const rotaAtual = location.pathname;

    // ==========================================================
    // CONTROLE DE ACESSO
    // ==========================================================

    let acessoNegado = false;

    // ==========================================================
    // TIPO "V" — SOMENTE VISUALIZAÇÃO
    //
    // O usuário "v" pode acessar somente a rota principal /maps.
    //
    // Qualquer outra rota será bloqueada, incluindo:
    // - Cadastros
    // - Edições
    // - Exclusões
    // - Gerenciamento de áreas e rotas
    // - Gerenciamento de usuários
    //
    // A comparação exata impede que /maps/usuarios, por exemplo,
    // seja liberada como se fosse a página principal do mapa.
    // ==========================================================

    if (tipo === "v") {
        acessoNegado = rotaAtual !== "/maps";
    }

    // ==========================================================
    // TIPO "U" — RESTRIÇÕES EXISTENTES
    //
    // Mantém o comportamento anterior:
    // bloqueia somente as rotas cadastradas em ROTAS_BLOQUEADAS.
    //
    // Também bloqueia subrotas.
    //
    // Exemplo:
    // /maps/grupos
    // /maps/grupos/123
    // ==========================================================

    if (tipo === "u") {
        acessoNegado = ROTAS_BLOQUEADAS.some((rota) => {
            return (
                rotaAtual === rota ||
                rotaAtual.startsWith(rota + "/")
            );
        });
    }

    // ==========================================================
    // ACESSO NEGADO
    //
    // Exibe a tela de restrição quando o usuário tenta acessar
    // uma rota que não está liberada para seu tipo.
    // ==========================================================

    if (acessoNegado) {
        return (
            <div className="restricao-usuario">
                <div className="restricao-usuario__card">

                    {/* ==================================================
                        IDENTIDADE INOVA
                    ================================================== */}

                    <div className="restricao-usuario__brand">
                        <span className="restricao-usuario__brand-dot" />
                        INOVA RASTREAMENTO
                    </div>

                    {/* ==================================================
                        ÍCONE DE SEGURANÇA
                    ================================================== */}

                    <div className="restricao-usuario__icon-wrapper">
                        <div className="restricao-usuario__icon-ring" />

                        <div className="restricao-usuario__icon">
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <rect
                                    x="5"
                                    y="10"
                                    width="14"
                                    height="10"
                                    rx="2"
                                    stroke="currentColor"
                                />

                                <path
                                    d="M8 10V7C8 4.79 9.79 3 12 3C14.21 3 16 4.79 16 7V10"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                />

                                <path
                                    d="M12 14V16"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </div>
                    </div>

                    {/* ==================================================
                        TÍTULO
                    ================================================== */}

                    <h1 className="restricao-usuario__title">
                        Acesso restrito
                    </h1>

                    {/* ==================================================
                        DESCRIÇÃO
                    ================================================== */}

                    <p className="restricao-usuario__description">
                        Você não possui permissão para acessar este recurso.
                        Esta área está disponível apenas para usuários
                        autorizados.
                    </p>

                    {/* ==================================================
                        STATUS
                    ================================================== */}

                    <div className="restricao-usuario__status">
                        <span className="restricao-usuario__status-dot" />
                        Permissão necessária
                    </div>

                    {/* ==================================================
                        AVISO
                    ================================================== */}

                    <div className="restricao-usuario__notice">
                        Caso precise acessar esta página, solicite ao{" "}

                        <strong>
                            administrador do sistema
                        </strong>{" "}

                        a liberação da permissão para o seu usuário.
                    </div>

                    {/* ==================================================
                        BOTÃO VOLTAR PARA O MAPA
                    ================================================== */}

                    <button
                        type="button"
                        className="restricao-usuario__button"
                        onClick={() => {
                            window.location.href = "/maps";
                        }}
                    >
                        Voltar para o mapa
                    </button>

                </div>
            </div>
        );
    }

    // ==========================================================
    // ACESSO PERMITIDO
    //
    // Se nenhuma restrição for acionada, renderiza normalmente
    // o componente ou a página solicitada.
    // ==========================================================

    return children;
}
